import { useMemo } from 'react';
import type { GroupBase, SelectComponentsConfig } from 'react-select';

import { commonProps } from './CustomComponents.tsx';
import type { Option } from './types.ts';

const { components: defaultComponents } = commonProps;

export const useMergeComponents = <TOption extends Option, TMulti extends boolean>(
  components: SelectComponentsConfig<TOption, TMulti, GroupBase<TOption>> | undefined,
): SelectComponentsConfig<TOption, TMulti, GroupBase<TOption>> => {
  return useMemo<SelectComponentsConfig<TOption, TMulti, GroupBase<TOption>>>(
    () => ({
      ...(defaultComponents as unknown as SelectComponentsConfig<TOption, TMulti, GroupBase<TOption>>),
      ...components,
    }),
    [components],
  );
};
